module.exports = __webpack_public_path__ + "img/email_banner.5e677065.png";